import { createTheme, ThemeOptions } from '@mui/material/styles';

const sharedTokens: ThemeOptions = {
  shape: { borderRadius: 10 },
  typography: {
    fontFamily:
      "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 8 } },
    },
    MuiTextField: {
      defaultProps: { size: 'small', fullWidth: true },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },
  },
};

export const lightTheme = createTheme({
  ...sharedTokens,
  palette: {
    mode: 'light',
    primary: { main: '#5b6cff' },
    secondary: { main: '#6e5cff' },
    background: { default: '#f5f7fb', paper: '#ffffff' },
    success: { main: '#2e7d32' },
    warning: { main: '#ed6c02' },
    error: { main: '#d32f2f' },
    info: { main: '#0288d1' },
  },
});

export const darkTheme = createTheme({
  ...sharedTokens,
  palette: {
    mode: 'dark',
    primary: { main: '#7a8aff' },
    secondary: { main: '#a59bff' },
    background: { default: '#0d0f14', paper: '#161922' },
    success: { main: '#66bb6a' },
    warning: { main: '#ffa726' },
    error: { main: '#ef5350' },
    info: { main: '#29b6f6' },
  },
});
